import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _inherits from "@babel/runtime/helpers/inherits";
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
import React, { Component } from 'react';

// eslint-disable-next-line @atlassian/tangerine/import/no-restricted-paths
import EngagementContextualSurvey from '../../ui/contextual-survey';
// eslint-disable-next-line @atlassian/tangerine/import/no-restricted-paths
import EngagementFlag from '../../ui/flag';
// eslint-disable-next-line @atlassian/tangerine/import/no-restricted-paths
import EngagementModalDialog from '../../ui/modal-dialog';
// eslint-disable-next-line @repo/internal/react/no-class-components
var EngagementMessages = /*#__PURE__*/function (_Component) {
  function EngagementMessages() {
    _classCallCheck(this, EngagementMessages);
    return _callSuper(this, EngagementMessages, arguments);
  }
  _inherits(EngagementMessages, _Component);
  return _createClass(EngagementMessages, [{
    key: "render",
    value: function render() {
      return /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(EngagementModalDialog, null), /*#__PURE__*/React.createElement(EngagementFlag, null), /*#__PURE__*/React.createElement(EngagementContextualSurvey, null));
    }
  }]);
}(Component); // duplicate the export as a named one. That way, the export name in
// this entrypoint (defined in "af:exports") matches the name that is
// used in the main (src/index.ts) entrypoint.
export { EngagementMessages as default };
export { EngagementMessages };